<script lang="ts">
  import { cx } from '@emotion/css';
  import { ResponsiveVars } from '@twist/core';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { isChartLarge } from '../utils/chart';

  interface Props {
    onViewChange: (newView: boolean) => void;
    showTable?: boolean;
    gridColspan: number;
  }

  let { onViewChange, showTable = false, gridColspan }: Props = $props();

  let offsetToggle = $state(false);

  const onToggleEnter = () => {
    offsetToggle = true;
  };

  const onToggleExit = () => {
    offsetToggle = false;
  };

  const responsiveVars = new ResponsiveVars()
    .addFluid('toolbar-gap', toFluidVarInput(9, 9))
    .addFluid('toolbar-on-left', toFluidVarInput(3, 3))
    .addFluid('toolbar-on-offset-left', toFluidVarInput(6, 6))
    .addFluid('toolbar-off-left', toFluidVarInput(13, 15))
    .addFluid('toolbar-off-offset-left', toFluidVarInput(10, 12))
    .addFluid('switch-width', toFluidVarInput(26, 30))
    .addFluid('switch-height', toFluidVarInput(13, 18))
    .addFluid('toggle-size', toFluidVarInput(9, 12))
    .addFluid('toggle-top', toFluidVarInput(2, 3))
    .addFluid('toggle-left', toFluidVarInput(3, 3))
    .toCSS();
</script>

<div
  class={cx('toolbar', responsiveVars, isChartLarge(gridColspan) && 'large-grid')}
  class:offset={offsetToggle}
  role="switch"
  aria-checked={!showTable}
  tabindex="0"
  onclick={() => onViewChange(!showTable)}
  onkeypress={() => onViewChange(!showTable)}
  onmouseover={onToggleEnter}
  onfocus={onToggleEnter}
  onmouseout={onToggleExit}
  onblur={onToggleExit}
>
  <span class="label" aria-hidden={showTable} class:selected={!showTable}>Chart</span>
  <span class="switch">
    <span class="toggle"></span>
  </span>
  <span class="label" aria-hidden={!showTable} class:selected={showTable}>Table</span>
</div>

<style lang="scss">
  @import 'src/scss/media';

  .toolbar {
    display: flex;
    align-items: center;
    justify-self: flex-end;
    gap: var(--toolbar-gap);
    padding: 6px 9px;
    border: 0 solid #005a9c;
    user-select: none;
    cursor: pointer;

    &[aria-checked='true'] .switch span {
      left: var(--toolbar-on-left);
    }

    &[aria-checked='true'].offset .switch span {
      left: var(--toolbar-on-offset-left);
    }

    &[aria-checked='false'] .switch span {
      left: var(--toolbar-off-left);
    }

    &[aria-checked='false'].offset .switch span {
      left: var(--toolbar-off-offset-left);
    }
  }

  .label {
    background: none;
    border: none;
    color: var(--twist-color-gray-60);
    font-family: var(--twist-font-family-pilat-wide);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    transition: color 0.1s ease-in;

    &.selected {
      color: var(--twist-color-gray-0);
      pointer-events: none;
    }
  }

  .switch {
    position: relative;
    display: inline-block;
    padding: 5px;
    background-color: #ffffff;
    border-radius: 12px;
    height: var(--switch-height);
    width: var(--switch-width);

    .toggle {
      position: absolute;
      display: inline-block;
      border-radius: 8px;
      background: black;
      transition: left 0.4s;

      top: var(--toggle-top);
      left: var(--toggle-left);
      height: var(--toggle-size);
      width: var(--toggle-size);
    }
  }
</style>
